module.exports = __webpack_public_path__ + "img/logo.4b531e65.svg";